import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';
import { useEffect } from 'react';

export const KSI_BICYCLIST_CRASH_LAYER_ID = 'ksiBicyclistCrashLayer';

const layerConfig = {
  title: 'KSI Bicyclist Crash Events',
};

function KSIBicyclistCrashLayer() {
  const dispatch = useDispatch();
  const { ksiBicyclistCrashLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) => selectSourceById(state, ksiBicyclistCrashLayer?.source));
  const cartoLayerProps = useCartoLayerProps({ source });
  const viewState = useSelector((state) => state.carto.viewState);
  
  // Calculate H3 resolution based on zoom level
  // Table's H3 index has a max resolution, so we aggregate up from there
  const getH3ResolutionFromZoom = (zoom) => {
    if (zoom >= 11) return 7;
    if (zoom >= 9) return 6;
    if (zoom >= 7) return 5;
    return 4;
  };
  
  const h3Resolution = getH3ResolutionFromZoom(viewState.zoom);

  if (ksiBicyclistCrashLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: KSI_BICYCLIST_CRASH_LAYER_ID,
      geoColumn: 'h3',
      aggregationExp: 'SUM(CASE WHEN S4_IS_BICYCLIST_INVOLVED AND is_ksi_crash = 1 THEN 1 ELSE 0 END) AS Bicyclist_KSI_Count',
      aggregationResLevel: h3Resolution,
      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: ksiBicyclistCrashLayer.visible,
      opacity: ksiBicyclistCrashLayer.opacity,
      extruded: false, // Ensure polygons are 2D
      polygonOffset: [1, 1], // Small padding between polygons

      getFillColor: colorBins({
        attr: 'Bicyclist_KSI_Count',
        domain: [1, 3, 4, 5],
        colors: [
          [251, 230, 197, 0], // 0 (transparent)
          [251, 230, 197],    // 1-2, #FBE6C5
          [245, 186, 152],    // 3, #F5BA98
          [220, 113, 118],    // 4, #DC7176
          [156, 63, 93],      // 5+, #9C3F5D
        ],
      }),


      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: KSI_BICYCLIST_CRASH_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
            }),
          };
        }
      },
    });
  }
}

export default KSIBicyclistCrashLayer;
